export const updateDocumentCustom = /* GraphQL */ `
mutation UpdateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    id
    name
    description
    data
    status
    fileUrl
    type
    hash
    createdAt
    updatedAt
    tags
    flowId
    annexes {
      name
      path
      description
      signaturesPositions {
        pageNumber
        boundingRect {
          x1
          x2
          y1
          y2
          width
          height
        }
        rects
      }
    }
    principal {
      name
      path
      description
      signaturesPositions {
        pageNumber
        boundingRect {
          x1
          x2
          y1
          y2
          width
          height
        }
        rects
      }
    }
    owner
    subgroups
    html
    group
    searchField
    bundleId
    flow
    markAsRead
  }
}
`;
